import { Authorization } from '@/widgets/Authorization'
import { useUser } from '@/widgets/user'

import { useCheckAuth } from '@/features/auth/check'
import { RemoveEntityProductModal } from '@/features/cart/remove-entity-products'

import { useCart } from '@/entities/cart'

import { Modal } from '@/shared/ui'

import { useBasketModals } from '../../hooks/use-basket-modals'
import cl from '../../styles.module.scss'
import { BasketMainContent } from '../basket-main-content/basket-main-content'
import { BasketSidebar } from '../basket-sidebar/basket-sidebar'
import { CartOrderBlockMobile } from '../cart-order-block-mobile/cart-order-block-mobile'
import { TopPanel } from '../top-panel/top-panel'

type BasketContentProps = {
	showAlert: boolean
}

export const BasketContent = ({ showAlert }: BasketContentProps) => {
	const { isJuridicalUser } = useUser()
	const { isAuthorized } = useCheckAuth()
	const { showOrderButton, bonusFromOrder, bonusPay, isLoading } = useCart()
	const { isAuthModalOpened, closeAuthModal } = useBasketModals()

	return (
		<>
			<section>
				<div className={cl.main}>
					<TopPanel />
					<div className={cl.content}>
						<BasketMainContent showAlert={showAlert} />
						{showOrderButton && (
							<>
								<BasketSidebar
									bonusFromOrder={bonusFromOrder}
									bonusPay={bonusPay}
									isJuridicalUser={isJuridicalUser}
									isAuthorized={isAuthorized}
									loading={isLoading}
								/>
								<CartOrderBlockMobile />
							</>
						)}
					</div>
				</div>
			</section>
			<Modal fullScreenOnMobile isOpen={isAuthModalOpened} onClose={closeAuthModal}>
				<Authorization />
			</Modal>
			<RemoveEntityProductModal />
		</>
	)
}
